@if (!!form) {
  <div>
    <div [formGroup]="form" class="row" (click)="toggleOption()">
      <div class="flex pad-horizontal-10">
        <input
          class="checkbox"
          type="checkbox"
          [id]="equipment?.optionKey"
          [formControlName]="equipment?.optionKey"
          (change)="toggleOption()"
          [attr.data-cy]="
            'equipmentChecklistCheckbox' +
            (equipment?.optionValue || equipment?.optionName | removeSpecialChars)
          "
        />
        <label class="checkbox-label" [attr.aria-label]="equipment.optionName"></label>
        <p class="pad-left-10">
          <span>{{ equipment.optionName }}</span
          ><br /><span class="caption">{{ equipment.caption }}</span>
        </p>
      </div>
    </div>
  </div>
}
